import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

export function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("certalyth_cookie_consent")) setShow(true);
  }, []);
  if (!show) return null;
  const decide = (v) => { localStorage.setItem("certalyth_cookie_consent", v); setShow(false); };
  return (
    <div className="fixed bottom-4 inset-x-4 md:inset-x-auto md:left-6 md:right-auto md:max-w-md z-[60] glass rounded-xl p-5 shadow-2xl animate-fadeup" data-testid="cookie-banner">
      <div className="flex items-start gap-3">
        <Cookie className="h-6 w-6 text-gold shrink-0 mt-0.5" />
        <div>
          <p className="text-sm text-slate-200 leading-relaxed">
            We use essential cookies for authentication and security. See our{" "}
            <Link to="/policies/cookies" className="text-gold underline">Cookie Policy</Link>.
          </p>
          <div className="flex gap-2 mt-4">
            <Button size="sm" className="btn-gold" data-testid="cookie-accept-btn" onClick={() => decide("accepted")}>Accept</Button>
            <Button size="sm" variant="secondary" data-testid="cookie-reject-btn" onClick={() => decide("essential")}>Essential only</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
